import React, { useState } from 'react'

import {
    Button,
    TextField,
    TextareaAutosize,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton,
    Divider,
    Box
} from '@mui/material'

import LoadingButton from '@mui/lab/LoadingButton'

import CloseIcon from '@mui/icons-material/Close'

export default function AddProductForm({ open, handleClose, submit, edit_id, edit_name, edit_description }) {

    const [id, setId] = useState(edit_id || null);
    const [name, setName] = useState(edit_name || '');
    const [description, setDescription] = useState(edit_description || '');

    return (
      <div>
        <Dialog
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={open}
          disablePortal
          disableEnforceFocus
          sx={{ position: "absolute" }}
        >
          <DialogTitle className="group-flexbox">
            Adicionar Produto ou Serviço
            <Button
              sx={{ minWidth: "2rem", padding: "0" }}
              onClick={handleClose}
            >
              <CloseIcon />
            </Button>
          </DialogTitle>
          <Divider />
          <DialogContent className="add-bot-dialog-content">
            <TextField
              size="small"
              label="Nome"
              fullWidth
              type="text"
              variant="outlined"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            <TextareaAutosize
              minRows={3}
              placeholder="Descrição"
              size="small"
              label="Descrição"
              className="textarea-description"
              variant="outlined"
              fullWidth
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
            <Box className="user-footer">
              <LoadingButton className="button-created" onClick={handleClose}>
                Cancelar
              </LoadingButton>
              <LoadingButton
                className="button-created"
                onClick={() => submit(id, name, description)}
                disabled={!name || !description}
              >
                Salvar
              </LoadingButton>
            </Box>
          </DialogContent>
        </Dialog>
      </div>
    );
}
